export const SESSION_LOGIN_SUCCESS = 'SESSION_LOGIN_SUCCESS';
export const SESSION_SET_INITIAL_STATE = 'SESSION_SET_INITIAL_STATE';
export const SESSION_UPDATE_PROFILE_NAME = 'SESSION_UPDATE_PROFILE_NAME';
export const SESSION_UPDATE_TEAM_LOGO = 'SESSION_UPDATE_TEAM_LOGO';
export const SESSION_UPDATE_THEME_NAME = 'SESSION_UPDATE_THEME_NAME';
